module.exports = {
    locale: $('meta[name="language"]').attr('content'),
    messages : {
        en: {
            compose : 'Compose',
            add_new_email : 'Add New Email',
            list_all_emails : 'List All Emails',
            smpt_details : 'SMTP Details',
            login_with : 'Login With',
            to_add_email : 'to add Email',
            other : 'SMTP',
            SMTP : 'SMTP',
            google_account : 'Gmail',
            microsoft_account : 'Outlook',
            email : 'Email',
            username : 'Username',
            smtp_username : 'SMTP username',
            smtp_host : 'SMTP Host',
            type : 'Type',
            added : 'Added',
            action : 'Action',
            delete : 'Delete',
            edit : 'Edit',
            from : 'From',
            to : 'To',
            subject : 'Subject',
            type_your_message : 'Type Your Message',
            attach_files : 'Attach Files',
            send : 'Send',
            email_address : 'Email address',
            password : 'Password',
            host : 'Outgoing server',
            port : 'Port',
            encryption : 'Encryption',
            create_account : 'Create Account',
            none: 'None',
            cc : 'CC',
            bcc : 'BCC',
            select_template : 'Select Template',
            save : 'Save',
            cancel : 'Cancel',
            email_sent : 'Email sent!',
            select_columns : 'Select Columns',
            close : "Close",
            select_field : 'Select Field',
            select_pdfs : 'Select PDFs',
            pdf_attachments : 'PDF Attachments',
            email_attachments : 'Email Attachments',
            pease_select_field : 'Please select field',
            please_select_column : 'Please select column',
            attach_pdfs : 'Attach PDFs',
            add_placeholder : 'Add Placeholder',
            choose_template : 'Choose Template',
            select_an_email_template : 'Select an email template',
            no_email : "You have not added any email address",
            add_email : 'Add Email Address'

        },
        sl: {
            compose : 'Novo',
            add_new_email : 'Dodaj novi račun',
            list_all_emails : 'Seznam vseh računov',
            smpt_details : 'SMTP podatki',
            login_with : 'Logiraj z',
            to_add_email : 'Dodaj Email',
            other : 'SMTP',
            google_account : 'Gmail',
            microsoft_account : 'Outlook',
            email : 'E-pošta',
            username : 'Uporabniško ime',
            smtp_username : 'SMTP Uporabniško ime',
            smtp_host : 'SMTP Odhodni strežnik',
            type : 'Vrsta',
            added : 'Dodano',
            action : 'Akcija',
            delete : 'Odstrani',
            edit : 'Uredi',
            from : 'Od',
            to : 'Do',
            subject : 'Zadeva',
            type_your_message : 'Vnesite sporočilo',
            attach_files : 'Dodaj priponke',
            send : 'Pošlji',
            email_address : 'E-pošta',
            password : 'Geslo',
            host : 'Strežnik za odhodno pošto',
            port : 'Port',
            encryption : 'Enkripcija',
            create_account : 'Kreiraj račun',
            none: 'Nič',
            select_template : 'Izberite predlogo',
            save : 'Shrani',
            cancel : 'Razveljavi',
            email_sent : 'Poslano!',
            select_columns : 'Izberite polje',

            close : "Zapri",
            select_field : 'Izberite polje',
            select_pdfs : 'Izberite PDF',
            pdf_attachments : 'PDF Priponke',
            email_attachments : 'E-poštne Priponke',
            pease_select_field : 'Izberite polje',
            please_select_column : 'Izberite stolpec',
            attach_pdfs : 'Pripni PDF',
            add_placeholder : 'Dodaj Placeholder',
            choose_template : 'Izberite predlogo',
            select_an_email_template : 'Izberite predlogo',

            no_email : " Potrebno je nastaviti e-poštni račun",
            add_email : 'Dodaj E-poštni račun'
        },
        hr: {
            compose : 'Compose',
            add_new_email : 'Add New Email',
            list_all_emails : 'List All Emails',
            smpt_details : 'SMTP Details',
            login_with : 'Login With',
            to_add_email : 'to add Email',
            other : 'SMTP',
            google_account : 'Gmail',
            microsoft_account : 'Outlook',
            username : 'Korisničko ime',
            smtp_username : "SMTP Korisničko ime",
            smtp_host : 'SMTP Host',
            type : 'Type',
            added : 'Added',
            action : 'Action',
            delete : 'Delete',
            edit : 'Uredi',
            from : 'From',
            to : 'To',
            subject : 'Subject',
            type_your_message : 'Type Your Message',
            attach_files : 'Priloži datoteke',
            send : 'Send',
            email_address : 'Email address',
            password : 'Password',
            host : 'Outgoing server',
            port : 'Port',
            encryption : 'Encryption',
            create_account : 'Create Account',
            none: 'None',
            cc : 'CC',
            bcc : 'BCC',
            select_template : 'Select Template',
            save : 'Save',
            cancel : 'Cancel',
            email_sent : 'Email sent!',
            select_columns : 'Select Columns',
            close : "Close",
            select_field : 'Select Field',
            select_pdfs : 'Select PDFs',
            pdf_attachments : 'PDF Attachments',
            email_attachments : 'Email Attachments',
            pease_select_field : 'Please select field',
            please_select_column : 'Please select column',
            attach_pdfs : 'Priložite PDF',
            add_placeholder : 'Add Placeholder',
            choose_template : 'Choose Template',
            select_an_email_template : 'Select an email template',
            no_email : "You have not added any email address",
            add_email : 'Add Email Address'
        },
        fi: {
            compose : 'Compose',
            add_new_email : 'Add New Email',
            list_all_emails : 'List All Emails',
            smpt_details : 'SMTP Details',
            login_with : 'Login With',
            to_add_email : 'to add Email',
            other : 'SMTP',
            SMTP : 'SMTP',
            google_account : 'Gmail',
            microsoft_account : 'Outlook',
            email : 'Email',
            username : 'Username',
            smtp_username : "SMTP username",
            smtp_host : 'SMTP Host',
            type : 'Type',
            added : 'Added',
            action : 'Action',
            delete : 'Delete',
            edit : 'Redagować',
            from : 'From',
            to : 'To',
            subject : 'Subject',
            type_your_message : 'Type Your Message',
            attach_files : 'Attach Files',
            send : 'Send',
            email_address : 'Email address',
            password : 'Password',
            host : 'Outgoing server',
            port : 'Port',
            encryption : 'Encryption',
            create_account : 'Create Account',
            none: 'None',
            cc : 'CC',
            bcc : 'BCC',
            select_template : 'Select Template',
            save : 'Save',
            cancel : 'Cancel',
            email_sent : 'Email sent!',
            select_columns : 'Select Columns',
            close : "Close",
            select_field : 'Select Field',
            select_pdfs : 'Select PDFs',
            pdf_attachments : 'PDF Attachments',
            email_attachments : 'Email Attachments',
            pease_select_field : 'Please select field',
            please_select_column : 'Please select column',
            attach_pdfs : 'Attach PDFs',
            add_placeholder : 'Add Placeholder',
            choose_template : 'Choose Template',
            select_an_email_template : 'Select an email template',
            no_email : "You have not added any email address",
            add_email : 'Add Email Address'
        },
        pl: {
            compose : 'Compose',
            add_new_email : 'Add New Email',
            list_all_emails : 'List All Emails',
            smpt_details : 'SMTP Details',
            login_with : 'Login With',
            to_add_email : 'to add Email',
            other : 'SMTP',
            SMTP : 'SMTP',
            google_account : 'Gmail',
            microsoft_account : 'Outlook',
            email : 'Email',
            username : 'Wybierz SMTP',
            smtp_username : "Nazwa użytkownika SMTP",
            smtp_host : 'Host SMTP',
            type : 'Type',
            added : 'Added',
            action : 'Action',
            delete : 'Delete',
            edit : 'Edit',
            from : 'From',
            to : 'To',
            subject : 'Subject',
            type_your_message : 'Type Your Message',
            attach_files : 'Załącz pliki',
            send : 'Send',
            email_address : 'Email address',
            password : 'Password',
            host : 'Outgoing server',
            port : 'Port',
            encryption : 'Encryption',
            create_account : 'Create Account',
            none: 'None',
            cc : 'CC',
            bcc : 'BCC',
            select_template : 'Select Template',
            save : 'Save',
            cancel : 'Cancel',
            email_sent : 'Email sent!',
            select_columns : 'Select Columns',
            close : "Close",
            select_field : 'Select Field',
            select_pdfs : 'Select PDFs',
            pdf_attachments : 'PDF Attachments',
            email_attachments : 'Email Attachments',
            pease_select_field : 'Please select field',
            please_select_column : 'Please select column',
            attach_pdfs : 'Attach PDFs',
            add_placeholder : 'Add Placeholder',
            choose_template : 'Choose Template',
            select_an_email_template : 'Select an email template',
            no_email : "You have not added any email address",
            add_email : 'Add Email Address'
        },
        it: {
            compose : 'Scrivi',
            add_new_email : 'Aggiungi nuova e-mail',
            list_all_emails : 'Elenco di tutte le e-mail',
            smpt_details : 'Dettagli SMTP',
            login_with : 'Accedi con',
            to_add_email : 'per aggiungere e-mail',
            other : 'SMTP',
            SMTP : 'SMTP',
            google_account : 'Gmail',
            microsoft_account : 'Outlook',
            email : 'E-mail',
            username : 'Nome utente',
            smtp_username : 'Nome utente SMTP',
            smtp_host : 'Host SMTP',
            type : 'Tipo',
            added : 'Aggiunto',
            action : 'Azione',
            delete : 'Elimina',
            edit : 'Modifica',
            from : 'Da',
            to : 'A',
            subject : 'Oggetto',
            type_your_message : 'Scrivi il tuo messaggio',
            attach_files : 'Allega file',
            send : 'Invia',
            email_address : 'Indirizzo e-mail',
            password : 'Password',
            host : 'Server in uscita',
            port : 'Porta',
            encryption : 'Crittografia',
            create_account : 'Crea account',
            none: 'Nessuna',
            cc : 'CC',
            bcc : 'CCN',
            select_template : 'Seleziona modello',
            save : 'Salva',
            cancel : 'Annulla',
            email_sent : 'E-mail inviata!',
            select_columns : 'Seleziona colonne',
            close : 'Chiudi',
            select_field : 'Seleziona campo',
            select_pdfs : 'Seleziona PDF',
            pdf_attachments : 'Allegati PDF',
            email_attachments : 'Allegati e-mail',
            pease_select_field : 'Seleziona un campo',
            please_select_column : 'Seleziona una colonna',
            attach_pdfs : 'Allega PDF',
            add_placeholder : 'Aggiungi segnaposto',
            choose_template : 'Scegli modello',
            select_an_email_template : 'Seleziona un modello di e-mail',
            no_email : 'Non hai aggiunto alcun indirizzo e-mail',
            add_email : 'Aggiungi indirizzo e-mail'
        },
        cs: {
            compose : 'Napsat',
            add_new_email : 'Přidat nový e-mail',
            list_all_emails : 'Seznam všech e-mailů',
            smpt_details : 'Údaje SMTP',
            login_with : 'Přihlásit se přes',
            to_add_email : 'pro přidání e-mailu',
            other : 'SMTP',
            SMTP : 'SMTP',
            google_account : 'Gmail',
            microsoft_account : 'Outlook',
            email : 'E-mail',
            username : 'Uživatelské jméno',
            smtp_username : 'Uživatelské jméno SMTP',
            smtp_host : 'Hostitel SMTP',
            type : 'Typ',
            added : 'Přidáno',
            action : 'Akce',
            delete : 'Smazat',
            edit : 'Upravit',
            from : 'Od',
            to : 'Komu',
            subject : 'Předmět',
            type_your_message : 'Napište svou zprávu',
            attach_files : 'Přiložit soubory',
            send : 'Odeslat',
            email_address : 'E-mailová adresa',
            password : 'Heslo',
            host : 'Server odchozí pošty',
            port : 'Port',
            encryption : 'Šifrování',
            create_account : 'Vytvořit účet',
            none: 'Žádné',
            cc : 'Kopie',
            bcc : 'Skrytá kopie',
            select_template : 'Vybrat šablonu',
            save : 'Uložit',
            cancel : 'Zrušit',
            email_sent : 'E-mail odeslán!',
            select_columns : 'Vybrat sloupce',
            close : 'Zavřít',
            select_field : 'Vybrat pole',
            select_pdfs : 'Vybrat PDF',
            pdf_attachments : 'Přílohy PDF',
            email_attachments : 'Přílohy e-mailu',
            pease_select_field : 'Vyberte pole',
            please_select_column : 'Vyberte sloupec',
            attach_pdfs : 'Přiložit PDF',
            add_placeholder : 'Přidat zástupný symbol',
            choose_template : 'Zvolit šablonu',
            select_an_email_template : 'Vyberte e-mailovou šablonu',
            no_email : 'Nepřidali jste žádnou e-mailovou adresu',
            add_email : 'Přidat e-mailovou adresu'
        },
        sk: {
            compose : 'Napísať',
            add_new_email : 'Pridať nový e-mail',
            list_all_emails : 'Zoznam všetkých e-mailov',
            smpt_details : 'Údaje SMTP',
            login_with : 'Prihlásiť sa cez',
            to_add_email : 'na pridanie e-mailu',
            other : 'SMTP',
            SMTP : 'SMTP',
            google_account : 'Gmail',
            microsoft_account : 'Outlook',
            email : 'E-mail',
            username : 'Používateľské meno',
            smtp_username : 'Používateľské meno SMTP',
            smtp_host : 'Hostiteľ SMTP',
            type : 'Typ',
            added : 'Pridané',
            action : 'Akcia',
            delete : 'Vymazať',
            edit : 'Upraviť',
            from : 'Od',
            to : 'Komu',
            subject : 'Predmet',
            type_your_message : 'Napíšte svoju správu',
            attach_files : 'Priložiť súbory',
            send : 'Odoslať',
            email_address : 'E-mailová adresa',
            password : 'Heslo',
            host : 'Server odchádzajúcej pošty',
            port : 'Port',
            encryption : 'Šifrovanie',
            create_account : 'Vytvoriť účet',
            none: 'Žiadne',
            cc : 'Kópia',
            bcc : 'Skrytá kópia',
            select_template : 'Vybrať šablónu',
            save : 'Uložiť',
            cancel : 'Zrušiť',
            email_sent : 'E-mail odoslaný!',
            select_columns : 'Vybrať stĺpce',
            close : 'Zavrieť',
            select_field : 'Vybrať pole',
            select_pdfs : 'Vybrať PDF',
            pdf_attachments : 'Prílohy PDF',
            email_attachments : 'Prílohy e-mailu',
            pease_select_field : 'Vyberte pole',
            please_select_column : 'Vyberte stĺpec',
            attach_pdfs : 'Priložiť PDF',
            add_placeholder : 'Pridať zástupný symbol',
            choose_template : 'Zvoliť šablónu',
            select_an_email_template : 'Vyberte e-mailovú šablónu',
            no_email : 'Nepridali ste žiadnu e-mailovú adresu',
            add_email : 'Pridať e-mailovú adresu'
        },
        fr: {
            compose : 'Nouveau message',
            add_new_email : 'Ajouter un nouvel e-mail',
            list_all_emails : 'Liste de tous les e-mails',
            smpt_details : 'Détails SMTP',
            login_with : 'Se connecter avec',
            to_add_email : 'pour ajouter un e-mail',
            other : 'SMTP',
            SMTP : 'SMTP',
            google_account : 'Gmail',
            microsoft_account : 'Outlook',
            email : 'E-mail',
            username : "Nom d'utilisateur",
            smtp_username : "Nom d'utilisateur SMTP",
            smtp_host : 'Hôte SMTP',
            type : 'Type',
            added : 'Ajouté',
            action : 'Action',
            delete : 'Supprimer',
            edit : 'Modifier',
            from : 'De',
            to : 'À',
            subject : 'Objet',
            type_your_message : 'Saisissez votre message',
            attach_files : 'Joindre des fichiers',
            send : 'Envoyer',
            email_address : 'Adresse e-mail',
            password : 'Mot de passe',
            host : 'Serveur sortant',
            port : 'Port',
            encryption : 'Chiffrement',
            create_account : 'Créer un compte',
            none: 'Aucun',
            cc : 'Cc',
            bcc : 'Cci',
            select_template : 'Sélectionner un modèle',
            save : 'Enregistrer',
            cancel : 'Annuler',
            email_sent : 'E-mail envoyé !',
            select_columns : 'Sélectionner les colonnes',
            close : 'Fermer',
            select_field : 'Sélectionner un champ',
            select_pdfs : 'Sélectionner des PDF',
            pdf_attachments : 'Pièces jointes PDF',
            email_attachments : 'Pièces jointes de l\'e-mail',
            pease_select_field : 'Veuillez sélectionner un champ',
            please_select_column : 'Veuillez sélectionner une colonne',
            attach_pdfs : 'Joindre des PDF',
            add_placeholder : 'Ajouter un espace réservé',
            choose_template : 'Choisir un modèle',
            select_an_email_template : 'Sélectionnez un modèle d\'e-mail',
            no_email : "Vous n'avez ajouté aucune adresse e-mail",
            add_email : 'Ajouter une adresse e-mail'
        }
    }
};